import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { EmpSalaryAllowComponent } from '../emp-salary-allow/emp-salary-allow.component';


@Component({
  selector: 'app-salary',
  templateUrl: './salary.component.html',
  styleUrls: ['./salary.component.css']
})
export class SalaryComponent implements OnInit {

  // employee_id: string;
  name: string;
  employee_no: string;
  basic_salary: string;
  goci_per_emp: string;
  goci_per_comp: string;
  emp_salary_id: string;
  index = 0;
  allowDialogRef: MatDialogRef<EmpSalaryAllowComponent>;

  dp = [];
  allow_list = [];
  emp_salary = [];

  monthList = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
  yearList = ['2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025'];

  model = {
    'table_name': 'emp_salary', 'emp_salary_id': '0', 'employee_no': '0', 'validity': '',
    'month': '', 'year': '', 'basic_salary': '', 'goci_per_emp': '', 'goci_per_comp': ''
  };

  /* allow_model = {
     'table_name': 'emp_salary_allow', 'emp_allow_id': '0', 'emp_salary_id': '0', 'allow_id': '0',
     'allow_perc': 0, 'is_goci': 0, 'allow_amount': 0
   };*/

  displayedColumns = ['allow_name', 'allow_amount', 'allow_perc', 'has_goci'];
  displayedColumns1 = ['allow_name', 'allow_amount', 'allow_perc', 'has_goci', 'edit', 'del'];
  dataSource = new MatTableDataSource(this.dp);
  dataSource1 = new MatTableDataSource(this.allow_list);
  @ViewChild(MatSort) sort: MatSort;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<SalaryComponent>, public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any) { }

  ngOnInit() {
    let today = new Date();
    let today_date = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
    this.employee_no = this.dialog_data['employee_no'];
    this.name = this.dialog_data['name'];
    // this.employee_id = this.dialog_data['employee_id'];

    let query = "SELECT * FROM `emp_salary` WHERE `status` = '1'  AND `employee_no` ='" + this.employee_no + 
      "' AND `validity` = (SELECT MAX(`validity`) FROM `emp_salary` WHERE `validity` <= '" + today_date + "')";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.emp_salary = data.data['list'];
        if (this.emp_salary.length != 0) {
          this.basic_salary = this.emp_salary['0']['basic_salary'];
          this.model['basic_salary'] = this.basic_salary;
          this.goci_per_emp = this.emp_salary['0']['goci_per_emp'];
          this.model['goci_per_emp'] = this.goci_per_emp;
          this.goci_per_comp = this.emp_salary['0']['goci_per_comp'];
          this.model['goci_per_comp'] = this.goci_per_comp;
          this.emp_salary_id = this.emp_salary['0']['emp_salary_id'];

          let validity = new Date(this.emp_salary['0']['validity']);
          this.model['month'] = String(validity.getMonth() + 1);
          this.model['year'] = String(validity.getFullYear() + 1);

          this.getAllowList();
        }
        else {
          this.model['month'] = String(new Date().getMonth() + 1);
          this.model['year'] = String(new Date().getFullYear());
        }
      });


  }

  getAllowList() {
    let query = "SELECT `emp_salary_allow`.*, `emp_allowance`.`allow_id`, `emp_allowance`.`allow_name`" +
      " FROM `emp_salary_allow`, `emp_allowance` WHERE `emp_salary_allow`.`status` ='1' AND " +
      "`emp_allowance`.`allow_id` = `emp_salary_allow`.`allow_id`  AND `emp_salary_allow`.`emp_salary_id` ='" + 
      this.emp_salary_id + "'";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        data.data['list'].forEach(element => {
          element.has_goci = (element.is_goci == '1' ? 'نعم' : 'لا');
        });
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;

        this.allow_list = data.data['list'];
        this.dataSource1 = new MatTableDataSource(this.allow_list);
        this.dataSource1.sort = this.sort;

      });
  }


  add() {
    if (this.model['basic_salary'] == '') {
      alert("الرجاء إدخال الراتب الأساسي");
      (document.getElementById('basic_salary') as HTMLInputElement).focus();
    }
    else {
      this.model['employee_no'] = this.employee_no;
      this.model['validity'] = this.model['year'] + "-" + this.model['month'] + "-01";
      delete this.model['year'];
      delete this.model['month'];
      let values = [];
      let values1 = [];
      values.push(this.model);

      let obj;
      let obj1;

      obj = { cmd: 'add', values: values };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            if(this.allow_list.length > 0) {
              this.allow_list.forEach(element => {
                values1.push({
                  'table_name': 'emp_salary_allow', 'emp_allow_id': '0', 'emp_salary_id': data.status['msg'][0]['id'], 
                  'allow_id': element.allow_id, 'allow_perc': element.allow_perc, 'is_goci': element.is_goci, 
                  'allow_amount': element.allow_amount
                });
              });
  
              obj1 = { cmd: 'add', values: values1 };
              this.utils.invokeHttp(this.applicationConstants.generalFile, obj1)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();
                  if (data.status['type'] == 'success') {
                    alert(" تمت العملية بنجاح ");
                    this.dialogRef.close(this.dialog_data);
                  }
                  else
                    alert(" حدث خطأ الرجاء المحاولة مرة أخرى "); 
                });
            }
            else {
              alert(" تمت العملية بنجاح ");
              this.dialogRef.close(this.dialog_data);
            }
          
          }
          else {
            alert(" حدث خطأ الرجاء المحاولة مرة أخرى ");
          }
        });
    }
    
  }


  empSalaryAllow() {
    if (this.model['basic_salary'] != '') {
      let dialog_data = {
        'basic_salary': Number(this.model['basic_salary']),
        'type': 'add',
        'index': this.index
      };
      this.allowDialogRef = this.dialog.open(EmpSalaryAllowComponent, {
        hasBackdrop: false,
        data: dialog_data
      });
      this.allowDialogRef
        .afterClosed()
        .subscribe(result => {
          
          if (result != dialog_data) {
            result.allow_detail.is_goci = (result.allow_detail.is_goci ? '1' : '0');
            result.allow_detail.has_goci = (result.allow_detail.is_goci == '1' ? 'نعم' : 'لا');
            
            this.allow_list.push(result.allow_detail);
            this.dataSource1 = new MatTableDataSource(this.allow_list);
            this.dataSource1.sort = this.sort;
          }
        });
      this.index++;
    }
    else
      alert("الرجاء إدخال الراتب الأساسي");

  }

  editAllow(row) {
    
    let dialog_data = {
      'type': 'edit',
      'allow_id': row.allow_id,
      'allow_perc': Number(row.allow_perc),
      'allow_amount': Number(row.allow_amount),
      'is_goci': row.is_goci,
      'basic_salary': Number(this.model['basic_salary']),
      'index': Number(row.index)
    };
    this.allowDialogRef = this.dialog.open(EmpSalaryAllowComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.allowDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != dialog_data) {
          let index = 0;
          this.allow_list.forEach(element => {
            if (element.index == result.allow_detail.index) {
              element = result.allow_detail;
              element.is_goci = (element.is_goci ? '1' : '0');
              element.has_goci = (element.is_goci == '1' ? 'نعم' : 'لا');
              
              this.allow_list[index] = element;
            }
            index++;
          });
          this.dataSource1 = new MatTableDataSource(this.allow_list);
          this.dataSource1.sort = this.sort;
        }
      });
  }

  delAllow(row) {
    if (confirm("هل أنت متأكد من رغبتك بحذف هذا البدل؟")) {
      this.allow_list.forEach(element => {
        if (element.index == row.index) {
          this.allow_list.splice(this.allow_list.indexOf(element), 1);
        }
      });

      this.dataSource1 = new MatTableDataSource(this.allow_list);
      this.dataSource1.sort = this.sort;
    }
  }


  cancel() {
    this.dialogRef.close(this.dialog_data);
    if (this.allowDialogRef)
      this.allowDialogRef.close();
  }

}
